<div>
   <div class="contents" *ngFor="let item of data;">
      <div class="title" [ngStyle]="{color: item.color}">
         <img [src]="'assets/2022/imgs/onlinelook/' + item.pcicon"> {{item.name}}
      </div>
      <div class="row" *ngFor="let row of item.childs">
         <a [href]="row.link" target="_blank">{{row.name}}</a><img src="assets/2022/imgs/onlinelook/experience_tip@2x.png" alt="">
      </div>
   </div>
</div>